import React from "react";
import { Button, Typography } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import List from './List';

const useStyles = makeStyles(() => ({
  input1: {
    height: 50
  },
  input2: {
    height: "200px"
  },
  root: { minWidth: 600, minHeight: 300 },
  marginTop20:{marginTop:'20px'},
  gridHeader: { paddingLeft: "5px", paddingBottom: "25px", paddingTop: "5px" },
  clr_title: { color: "rgba(74, 74, 74, 1)", fontSize: "20px" },
}));
export default function FormDialog(props) {
  const classes = useStyles();
  const [values, setValues] = React.useState("");
  const [listvalue, setListValues] = React.useState([]);
  const [edit, setEdit] = React.useState(false);
  const [id, setId] = React.useState(0);

  React.useEffect(() => {
    if (props.text.type === "list") {
      for (let i = 0; i < props.text.value.length; i++) {
        listvalue.push(props.text.value[i]);
      }
    }
    setListValues([...listvalue]);
  }, []);
  const handleDelete = delid => {
    const deletedtext = listvalue.filter(item => item.id !== delid);
    setListValues(deletedtext);
  };

  const handleClose = () => {
    setValues("");
    setEdit(false);
  };
  const handleEdit = editid => {
    const edittext = listvalue.find(item => item.id === editid);
    setValues(edittext.value);
    setEdit(true);
    setId(editid);
  };
  const handleList = value => {
 if(value.length>0){
    if (edit) {
      listvalue.map(list => {
        return list.id === id ? (list.value = value) : "";
      });
      setEdit(false);
    } else {
      let list = {
        id: Date(),
        value: value
      };
      listvalue.push(list);
    }
    setListValues([...listvalue]);
    props.setTexts(listvalue);
    setValues("");
}
  };
  const handleChange = changedVal => {
    setValues(changedVal.target.value);

  };
  const handleChange1 = changedVal => {
    props.setTexts(changedVal.target.value);

  };
  return (
    <div className={classes.marginTop20}>
      <Card variant="outlined">
        <CardContent>
          {props.text.type !== "list" ? (
            <>
           {props.text.type === 'paragraph' ? (
            // This is for paragraph field
              <div>
              {" "}
              <Button size="small" onClick={() => props.handleDeletetext(props.text.id)} style={{ float: "right" }} >
                <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "14px", color: "red" }} />
              </Button>
              <Typography className={classes.gridHeader}>
                <b className={classes.clr_title}>
                  Paragraph
                  </b>
              </Typography>
              <TextareaAutosize
                style={{width: "100%" } }
                multiline={1}
                id="name"
                label="Paragraph"
                value={props.text.value || ""}
                placeholder="Paragraph"
                onChange={handleChange1}
                variant="filled"
                rowsMin={8}
              />
            </div>
           ) : (
            //  This is for header field
            <div>
            {" "}
            <Button size="small" onClick={() => props.handleDeletetext(props.text.id)} style={{ float: "right" }} >
              <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "14px", color: "red" }} />
            </Button>
            <TextField
              id="name"
              label={props.text.type}
              value={props.text.value || ""}
              onChange={handleChange1}
              variant="filled"
            />
          </div>
          )
          }
</>
          ) : (
            <div>
              <Button size="small" onClick={() => props.handleDeletetext(props.text.id)} style={{ float: "right" }} >
                <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "14px", color: "red" }} />
              </Button>
              <TextField
                id="name"
                label={props.text.type}
                value={values || ""}
                onChange={handleChange}
                variant="filled"
              />
            </div>
          )}
          {props.text.type === "list" ? (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {" "}
              {edit ? (
                <Button onClick={handleClose} color="primary"> Cancel </Button>
              ) : (
                ""
              )}
              <Button onClick={() => handleList(values)} color="primary"> {edit ? "EDIT" : "ADD LIST"} </Button>
            </div>
          ) : (
            ""
          )}

          {props.text.type === "list" ? (
            <>
              {listvalue ? (
                !props.text.ul ? (
                  <ol style={{marginLeft:'20px'}}>
                <List list={listvalue} handlelistEdit={handleEdit} handlelistDelete={handleDelete}/>
                  </ol>
                ) : (
                  <ul style={{marginLeft:'20px'}}>
                  <List list={listvalue} handlelistEdit={handleEdit} handlelistDelete={handleDelete}/>
                  </ul>
                )
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </CardContent>
      </Card>
    </div>
  );
}
